export default {"src":"/_next/static/media/net.05a6adb0.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};